/* =============================================================================
   The header band every full-screen modal shares: optional back arrow, title,
   optional close. Kept in one place so the product builder, the store picker
   and the loyalty pages cannot drift apart.

   onBack / onClose are omitted rather than passed as null when the control
   should not exist — several pages deliberately have no close (the customer
   must choose "Continue as guest" or pick a store) and an inert ✕ would invite
   a click that does nothing.
   ============================================================================= */
export default function ModalHead(props) {
    return (
        <div className="wo-pm__head">
            {props.onBack &&
                <button type="button" className="wo-pm__back" onClick={props.onBack}
                        disabled={props.backDisabled} aria-label="Back">
                    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                         strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M15 18l-6-6 6-6" />
                    </svg>
                </button>}

            <h2 className="wo-pm__title">{props.title}</h2>

            {props.onClose &&
                <button type="button" className="wo-pm__close" onClick={props.onClose}
                        disabled={props.closeDisabled} aria-label="Close">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                         strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
                        <path d="M6 6l12 12M18 6L6 18" />
                    </svg>
                </button>}
        </div>
    );
}
